import { Dispatch } from 'react'
import NotificationService from 'services/Notification'
import { featureFlags } from 'config/featureFlags'
import { listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'

// Perfis permitidos para tratamento em grupo: Admin, Qualidade da unidade e Gestor da unidade
const ALLOWED_GROUP_TREATMENT_PROFILES = [
    listOfRoles.admin,
    listOfRoles.location_qa,
    listOfRoles.location_manager
]

export const canUseGroupTreatment = (userProfile?: string): boolean => {
    if (!userProfile) return false
    return ALLOWED_GROUP_TREATMENT_PROFILES.includes(userProfile as any)
}

export const emptyNotificationsText = (navItem: any) => {
    if (navItem) {
        const noNotificationText = 'Não há Notificações'
        switch (navItem.id) {
            case 2:
                return `${noNotificationText} ${navItem.name.toLowerCase()} tratamento`
            case 4:
                return `${noNotificationText} finalizadas`
            case 7:
                return `${noNotificationText} em seu nome`
            case 8:
                return `${noNotificationText}`
            default:
                return `${noNotificationText} ${navItem.name.toLowerCase()}`
        }
    }
    return 'Não há Notificações'
}

export const notificationAnalizer = (
    currentNotificationSelected: any,
    notificationsList: any,
    setNotificationsList: Dispatch<any>,
    navigate: any,
    handleShowGroupTreatmentModal?: (groupCount: number) => void,
    userProfile?: string
) => {
    // Verificar se currentNotificationSelected não é null ou undefined
    if (!currentNotificationSelected) {
        return
    }

    if (featureFlags.groupNotifications) {
        // Check if notification state is 3 (in group treatment) or 5 (finished with group), navigate to group treatment page
        // TODOS podem ver grupos já criados, então não validamos permissão aqui
        if (currentNotificationSelected.u_state?.value == 3 || currentNotificationSelected.u_state?.value == 5) {
            const groupId = currentNotificationSelected?.u_treatment_group?.value
            if (groupId && groupId !== '') {
                // Permite acesso para todos os perfis (grupo já foi criado)
                navigate(`/notificacoes/group-treatment/${groupId}`, { 
                    state: { selectedNotification: currentNotificationSelected }
                })
                return
            } else {
                // Se u_treatment_group estiver vazio, vai para tratamento normal
                console.log('u_treatment_group vazio, redirecionando para tratamento normal')
                // Continua o fluxo normal (não faz return aqui)
            }
        }

        // Check if notification is eligible for group treatment AND u_treatment_group is empty
        // AQUI validamos apenas para CRIAR grupo (quando status é "aguardando")
        const hasNoTreatmentGroup =
            !currentNotificationSelected?.u_treatment_group?.value ||
            currentNotificationSelected?.u_treatment_group?.value === ''

        // Validar se o perfil do usuário pode CRIAR tratamento em grupo
        // Apenas Admin, Qualidade da unidade e Gestor da unidade podem CRIAR grupos
        const userCanCreateGroupTreatment = canUseGroupTreatment(userProfile)

        if (
            currentNotificationSelected.eligible_for_group_treatment &&
            hasNoTreatmentGroup &&
            handleShowGroupTreatmentModal &&
            userCanCreateGroupTreatment
        ) {
            const groupCount =
                currentNotificationSelected.group_treatment_count || 0
            // Só permitir grupos com 2 ou mais notificações
            if (groupCount >= 2) {
                handleShowGroupTreatmentModal(groupCount)
            }
            return
        }
    }

    if (currentNotificationSelected.u_notification_read) {
        currentNotificationSelected.u_notification_read = {
            display_value: 'true',
            value: 'true'
        }
    }

    NotificationService.readerNotification(
        currentNotificationSelected.sys_id.value,
        currentNotificationSelected
    )
        .then((response: any) => {
            let newListNotifications = [...notificationsList]
            newListNotifications.forEach((notification) => {
                if (
                    notification.sys_id.value ===
                    currentNotificationSelected.sys_id.value
                ) {
                    notification.u_notification_read = true
                }
            })

            setNotificationsList(newListNotifications)
            navigate(
                `/notificacoes/${currentNotificationSelected.sys_id.value}`
            )
        })
        .catch((error) => {
            console.log(error)
        })
}
